module.exports = __webpack_public_path__ + "img/complete.6c9d586f.svg";